import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { useTrigger } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useTrigger';

interface useOnDialogOpenProps {
  index: number;
  isNewCartItem: boolean;
  open: boolean;
}

export const useOnDialogOpen = ({ index, isNewCartItem, open }: useOnDialogOpenProps) => {
  const { cart } = useCart();
  const { setValue } = useFormContext();

  const { trigger: doUpdateFromCart } = useTrigger({
    callback: () => {
      setValue('item', cart?.items[index].toFormItem(), {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    },
  });

  useEffect(() => {
    if (!isNewCartItem) {
      doUpdateFromCart();
    }
  }, [open]);
};
